import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingVatReturnResource } from "@exonn/js-sdk";

/**
 * UStVA snapshots (S4). "Create" computes the draft of an owner and period (the
 * backend store endpoint is the compute); a snapshot is never edited or deleted –
 * everything else happens through the workflow actions in the detail toolbar.
 */
export const module: ModuleOptions<AccountingVatReturnResource> = {
  resource: ResourceEnum.AccountingVatReturn,
  bigIcon: <span className={"icon-20-bills"} />,
  smallIcon: <span className={"icon-15-bills"} />,
  disableDelete: true,
  tabs: {
    edit: {
      getTitle: (resource) =>
        `UStVA ${resource.period_label} · V${resource.version}`,
    },
  },
};
